export default __webpack_public_path__ + "static/media/kyc-selfie-illustration-good-it.982ac1d1.svg";